const state = {
  /**
   * actions is an array of objects with these fields:
   * id: String
   * * Unique identifier for the action
   * type: String
   * * Either 'add', 'edit', or 'delete'
   * changes: String[]
   * * { name } for adds/deletes
   * * { name, oldValue, newValue } for  edits
   * action: function(resolve, reject)
   * * An anonymous function that calls resolve() or reject() when finished
   * * If the resolve or reject returns a String then it will be toasted
   */
  actions: [],
};

const getters = {
  actions: state => state.actions,
};

const mutations = {
  addAction(state, action) {
    const index = state.actions.findIndex(a => a.id === action.id);
    if (index > -1) {
      state.actions.splice(index, 1);
    }
    state.actions.push(action);
  },
  removeAction(state, id) {
    state.actions = state.actions.filter(action => action.id !== id);
  },
  clearActions(state) {
    state.actions = [];
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
